<template>
  <div class="container">
		<div class="head">
			<img src="../../assets/advertisement/introduceFour/banner.png" alt="">
		</div>
		<div class="z_nav" :class="{fix: Fixed}">
    	<div class="m_nav">
				<div class="m_nav_r">
					<ul>
						<li>
							<a @click="btn1">
								<div>
									<p class="tit-top" :class="{active: b1_a}">百草之王</p>
									<p class="tit-bottom" :class="{active: b1_a}">冬蟲夏草</p>
								</div>
							</a>
						</li>
						<li>
							<a @click="btn2">
								<div>
									<p class="tit-top" :class="{active: b2_a}">研究證實</p>
									<p class="tit-bottom" :class="{active: b2_a}">冬蟲夏草的適用人群</p>
								</div>
							</a>
						</li>
						<li>
							<a @click="btn3">
								<div>
									<p class="tit-top" :class="{active: b3_a}">中醫說蟲草</p>
									<p class="tit-bottom" :class="{active: b3_a}">冬蟲夏草的功能主治</p>
								</div>
							</a>
						</li>
						<li>
							<a @click="btn4">
								<div>
									<p class="tit-top" :class="{active: b4_a}">西醫說蟲草</p>
									<p class="tit-bottom" :class="{active: b4_a}">冬蟲夏草的功效機理</p>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="z_md_one">
			<div class="one">
				<div class="banner">
					<img src="../../assets/advertisement/introduceFour/effectbannerbg1.png" alt="">
				</div>
				<p>中醫藥界流傳著“中藥三大寶，人參、鹿茸、冬蟲夏草”的說法，冬蟲夏草的藥用價值、滋補功效更是位居三大寶之首，比人參和鹿茸也更具傳奇色彩。以至於很多人聽說過它，卻又對它知之甚少。</p>
				<p>冬蟲夏草的應用歷史，可以一直追溯到3000年前，<b>有明確醫書記載的藥用歷史，也有1300多年。在中醫典籍的記載中，賦予冬蟲夏草至高的評價：得陰陽之氣全也。秘精益氣，專補命門。治諸虛百損，老少病虛者皆宜食用……</b></p>
				<p>在西方，從1726年冬蟲夏草在法國科學院學術會上第一次被介紹和展示，獨特的功效吸引了歐美、日本、東南亞國家競相研究，從藥理學研究到分子生物學探索。<b>到今天，已經有數個西藥新藥來源於冬蟲夏草……</b></p>
				<p class="small">在科技越來越發達的今天，冬蟲夏草陰陽同步的多重應用價值已經被現代科學明確證實。不僅歷代傳統中醫藥典籍有詳細的記載，我國當代的藥學法典《中華人民共和國藥典》、《中華人民共和國藥典臨床用藥須知》、國家統編中醫藥學教材《中藥學》、醫藥學專著《中藥大辭典》、《中醫大辭典》、《中華本草》等更是詳實的介紹了冬蟲夏草的作用。</p>
				<p>1.中華人民共和國藥典(冬蟲夏草)[2010年版壹部].國家藥典委員會編.中國醫藥科技出版社.</p>
				<p>2.中華人民共和國藥典臨床用藥須知(冬蟲夏草)[中華飲片卷(2010年版)].國家藥典委員會編.中國醫藥科技出版社.</p>
				<p>3.中藥學(冬蟲夏草)[新世紀(第二版)全國高等中醫藥院校規劃教材].主編高學敏.中國中醫藥出版社.</p>
				<p>4.中藥學(冬蟲夏草)[中醫藥學高級叢書(第2版)]."十一五"國家重點圖書.主編高學敏,鐘贛生.人民衛生出版社.</p>
				<p>5.中華本草(冬蟲夏草)國家中醫藥管理局《中華本草》編委會.上海科學技術出版社.</p>
				<p>6.中藥大辭典(冬蟲夏草)(第二版).南京中醫藥大學編著.上海科學技術出版社.</p>
				<p>7.中醫大辭典(冬蟲夏草)(第二版).主編中國中醫研究院,廣州中醫藥大學.人民衛生出版社.</p>
				<p>8.中國大百科全書(中國傳統醫學).中國傳統醫學編委會.中國大百科全書出版社.</p>
				<a name="b"></a>
				<div>
					<img src="../../assets/advertisement/introduceFour/books.jpg" alt="">
				</div>
			</div>
			<div class="two" style="padding-top:50px">
				<div class="banner">
					<img src="../../assets/advertisement/introduceFour/effectbannerbg2.png" alt="">
				</div>
				<div>
					<ul>
						<li>
							<p>健康人滋補養生，調節內分泌功能，補腎壯陽、滋陰</p>
						</li>
						<li>
							<p>亞健康狀態</p>
						</li>
						<li>
							<p>因工作負荷大、睡眠不足、應酬過多等情況導致的體力精力透支、免疫機能低下、易於感冒、乏力、急躁、自覺衰老過快等</p>
						</li>
						<li>
							<p>體弱及年老體質衰退者的調理</p>
						</li>
						<li>
							<p>吸煙與飲酒人群、長期服用各種藥物者的養生</p>
						</li>
						<li>
							<p>癌症的預防與輔助治療、放化療的增效減毒</p>
						</li>
						<li>
							<p>糖尿病及其併發症(如糖尿病腎病等)</p>
						</li>
						<li>
							<p>過敏或有過敏疾病的人</p>
						</li>
						<li>
							<p>肝病、腎病、肺病、血液病等</p>
						</li>
						<li>
							<p>器官移植術後</p>
						</li>
						<li>
							<p>重病或手術後恢復</p>
						</li>
						<li>
							<p>心腦血管病、動脈硬化、高血脂、高血壓等</p>
						</li>
					</ul>
				</div>
			</div>

			<div class="three">
				<div class="banner">
					<img src="../../assets/advertisement/introduceFour/effectbannerbg3.png" alt="">
				</div>
				<div>
					<h4>中醫科學實踐證實</h4>
					<h4>冬蟲夏草是唯一具有陰陽同補作用的藥物</h4>
					<h4 style="margin-bottom:40px;">被譽為“治諸虛百損之聖藥”</h4>

					<h5>得陰陽之氣全也</h5>
					<h5>秘精益氣，專補命門</h5>
					<h5>治諸虛百損</h5>
					<h5>老少病虛者皆宜食用……</h5>
					<p>冬蟲夏草用於滋補養生、強身莊體、疾病治療的文字記載，從公元710年的《月王藥診》(亦譯《醫法月王論》)開始，之後《臧本草》、《圖鑒》、《吾三卷香》、《金汁甘露寶瓶刊記》、《壽世保元》、《本草備要》、《本草二經》、《黔囊》、《本草問答》、《本草從新》、《本草綱目拾遺》、《藥性考》(原名《太醫院手記》)、《本草再新》、《柑園小識》、《四川通志》、《本草圖說》、《文房肆考》、《本草正義》、《重慶堂隨筆》等典籍中都從個角度記載了冬蟲夏草：</p>
					<p>入肺、腎經。甘、平。保肺、益腎、止血、化痰、已勞嗽。治膈症皆良。</p>
					<a name="d"></a>
					<p>味甘、性溫、秘精益氣，專補命門……甘平，保肺益腎，補精髓，止血化痰，已勞嗽，治膈症皆良。</p>
					<p>治膈癥，蟲脹，病後虛損……以其得陰陽之氣全也……功與人參、鹿茸同，但藥性溫和，老少病虛者皆宜食用。</p>
					<p>冬蟲夏草，具溫和平補之性，為虛瘧，虛痞，虛脹，虛痛之聖藥……飯陰虛陽亢而為喘逆痰嗽者，投之悉效，不但調經種子有轉能也。</p>
				</div>
			</div>
		</div>
		<div class="effect">
    	<div class="z_effect">
      	<div class="banner">
        <img src="../../assets/advertisement/introduceFour/effectbannerbg4.png" alt="">
      </div>
      <ul class="z_effect_li">
        <li @click="choose_1" :class="{on: On[0].isOn}">1、調節內分泌，改善下丘腦-垂體- 性腺軸功能</li>
        <li @click="choose_2" :class="{on: On[1].isOn}">2、雙向調節免疫系統功能</li>
        <li @click="choose_3" :class="{on: On[2].isOn}">3、預防與直接抗腫瘤作用，協同放化療效果、減輕毒副作用</li>
        <li @click="choose_4" :class="{on: On[3].isOn}">4、抗自由基、抗氧化，抗衰老，增強記憶力</li>
        <li @click="choose_5" :class="{on: On[4].isOn}">5、提高細胞能量、促進機體損傷修復，抗缺氧、抗疲勞</li>
        <li @click="choose_6" :class="{on: On[5].isOn}">6、調節血糖、保護胰腺β細胞、促進機體對糖的利用</li>
        <li @click="choose_7" :class="{on: On[6].isOn}">7、調節呼吸系統功能</li>
        <li @click="choose_8" :class="{on: On[7].isOn}">8、調節肝臟功能</li>
        <li @click="choose_9" :class="{on: On[8].isOn}">9、調節腎臟功能</li>
        <li @click="choose_10" :class="{on: On[9].isOn}">10、調節造血機能</li>
        <li @click="choose_11" :class="{on: On[10].isOn}">11、調節心血管系統功能，調節血液流變學，調節血脂</li>
      </ul>
      <div class="z_effect_r">
        <div v-if="part[0].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">1、 調節內分泌，改善下丘腦- 垂體- 性腺軸功能</h4>
          <div class="red-h4">
            <h4>補腎壯陽、滋陰</h4>
            <h4>改善性功能與生殖功能</h4>
            <h4>緩解更年期症狀</h4>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草治療遺精15例臨床觀察》結果顯示：</p>
            <h4>冬蟲夏草能補益腎精，用於遺精的治療</h4>
            <p>冬蟲夏草治療遺精總有效率為86.67%</p>
          </div>
          <div class="flex">
              <div>
                <img src="../../assets/advertisement/introduceFour/pro_tab1.jpg" alt="">
              </div>
            <div>
              <p>成年男子偶有遺精，次日並無任何不適者，屬生理現象，不是病症。若3-5天遺精1次，甚至晝夜遺精次數無定，並有頭暈神疲、腰酸腿軟、心慌氣短等症狀者，則為病態，必須及時治療。</p>
              <p>本研究選擇15名遺精患者，治療方式為每3-4天服冬蟲夏草25-30克，間隔3-4天后重複上述用量，4次一療程。</p>
              <p>療效標準參照《中藥新藥臨床研究指導原則》擬定。臨床治愈：有正常性生活者不再遺精，無正常性生活者每月遺精少於5次；顯效：有正常性生活者每月遺精仍有1-2次，無正常性生活者每週遺精減少2次以上；有效：有正常性生活者每月遺精仍有2-3次，無正常性生活者每週遺精減少1次；無效：治療前後無變化。治療結果顯示，冬蟲夏草治療遺精總有效率為86.67％ 。</p>
              <p>冬蟲夏草治療遺精15例臨床觀察.當代醫學，2008（142）.</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草對生育力影響的實驗研究》結果顯示：</p>
            <h4>冬蟲夏草有擬雄激素樣作用，對性功能紊亂有調節恢復正常的作用</h4>
            <p>精液囊重量（mg/100g）</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab2.jpg" alt="">
            </div>
            <div>
              <p>睾丸是男性的主要性器官，既是產生精子的場所，又具有合成和分泌雄激素（睾酮）的功能。睾丸功能的正常，對精子的成熟與活力有重要影響。</p>
              <p>本實驗觀察了對成年雄性小白鼠精液囊重量的影響。將實驗鼠分為兩批，一批摘除睾丸模擬雄激素分泌水平低下的情況，在10天后，隨機分為對照組和冬蟲夏草組，冬蟲夏草組每天給予冬蟲夏草5克/千克體重，連續7天，第8天取精液囊稱重。另一批則不摘除睾丸，同樣方法，檢測精液囊重量並觀察精子數量與活動力。</p>
              <p>結果顯示：對於模擬雄激素分泌水平低下的小鼠，冬蟲夏草組與對照組比較，差別有顯著性（P
                &lt;0.05），表明冬蟲夏草有擬雄激素樣作用，對性功能紊亂有調節恢復正常的作用。</p>
                  <p>而冬蟲夏草對正常雌性小鼠、雄性（未摘除睾丸小鼠）的生育力、子宮重量、精液囊重量、精力數量與活力無明顯影響。</p>
                  <p>冬蟲夏草對生育力影響的實驗研究 . 廣西中醫藥，1990，13（6）.</p>
            </div>
          </div>
          <hr>
          <ul class="ul_li">
            <li>冬蟲夏草治療遺精15例臨床觀察</li>
            <li>冬蟲夏草的臨床運用</li>
            <li>冬蟲夏草提高“腎陽虛”小鼠生殖功能的實驗研究</li>
            <li>冬蟲夏草對生育力影響的實驗研究</li>
            <li>蟲草膏滋陰補腎作用研究</li>
          </ul>
        </div>
        <!--<div><img src="../../assets/advertisement/introduceFour/z_effect2.jpg" alt=""></div>-->
        <div v-if="part[1].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">1、 調節內分泌，改善下丘腦- 垂體- 性腺軸功能</h4>
          <div class="red-h4">
            <h4>增強免疫力：滋補強壯，治諸虛百損，降低疾病發生風險</h4>
            <h4>抑制異常免疫：抗過敏，拮抗器官移植後的排斥反應</h4>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草對腦梗塞患者免疫功能影響的研究》結果顯示：</p>
            <h4>冬蟲夏草用於改善腦梗塞患者的免疫功能療效確切，效果顯著</h4>
            <p>冬蟲夏草組治療前後細胞免疫指標比較</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab3.jpg" alt="">
            </div>
            <div>
              <p>多數研究表明，腦梗塞患者外周血中細胞免疫指標CD3+、CD4+、CD4+/CD8+顯著降低，CD8+升高，T細胞亞群發生變化，細胞免疫功能低下，免疫調節能力下降。</p>
              <p>本研究隨機選擇60例腦梗塞患者，30例為冬蟲夏草組，30例為對照組。對照組給予脫水劑、腦保護劑等常規治療，30天一療程。冬蟲夏草組在此基礎上，每天加服冬蟲夏草2克。檢測治療前後的免疫指標的變化並對比，觀察冬蟲夏草對腦梗塞患者免疫功能的影響。</p>
              <p>結果顯示：冬蟲夏草可以明顯提高CD3+、CD4+、CD4+/CD8+，降低CD8+，從而顯著改善腦梗塞細胞免疫功能（P
                &lt;0.001），促進病情恢復。</p>
                  <p>冬蟲夏草對腦梗塞患者免疫功能影響的研究 . 中華臨床新醫學，2004，4（7）.</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草對小鼠淋巴細胞增殖和IL-2產生的作用》結果顯示：</p>
            <h4>冬蟲夏草可以明顯增強機體的免疫功能</h4>
            <p>冬蟲夏草對脾淋巴細胞增殖反應和IL-2產生的影響</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab4.jpg" alt="">
            </div>


            <div>
              <p>脾臟是機體最大的免疫器官，佔全身淋巴組織總量的25%，含有大量的淋巴細胞和巨噬細胞，是機體細胞免疫和體液免疫的中心。 IL-2（白細胞介素-2，又名T細胞生長因子），可促進T淋巴細胞的增殖，也參與抗體反應、造血和腫瘤監視。</p>
              <p>本研究將實驗動物隨機分為兩組，對照組給予生理鹽水灌胃，冬蟲夏草組給予冬蟲夏草灌胃，連續給藥15天。檢測脾淋巴細胞增殖程度及IL-2的誘生與活性。</p>
              <p>結果顯示：冬蟲夏草組促進脾淋巴細胞增殖反應效果顯著，細胞因子IL-2的產生明顯增強，與對照組相比有非常顯著性差異( P
                &lt; 0.01) ，這表明，冬蟲夏草可以明顯增強機體的免疫功能。</p>
                  <p>冬蟲夏草對小鼠淋巴細胞增殖和IL-2產生的作用 . 濱州醫學院學報，2008，3（13）.</p>
            </div>
          </div>
          <div class="title-tio">
            <p>《冬蟲夏草水提物對巨噬細胞吞噬功能的實驗研究》結果顯示：</p>
            <h4>冬蟲夏草可以增強巨噬細胞的吞噬功能，提高機體免疫力，其作用隨劑量增大而增強</h4>
            <p>冬蟲夏草對巨噬細胞吞噬功能的影響吞噬指數</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab5.jpg" alt="">
            </div>
            <div>
              <p>巨噬細胞是一種位於組織內的白血球，源自單核細胞，這種細胞在機體正常發育、體內平衡、組織修復和對病原體的免疫反應中扮演了許多不同的角色。這也就是說，幾乎每一種人類疾病都涉及它們，它們也是主要治療目標，因為它們的功能可以被加強或抑制，以改變疾病的結果。巨噬細胞吞噬指數可做為機體免疫功能，尤其是機體抗腫瘤能力的判斷指標之一。</p>
              <p>本研究將實驗動物隨機分為四組，冬蟲夏草高、中、低劑量組，分別按每千克體重5克、3.3克、1.7克冬蟲夏草灌胃，對照組給予等容生理鹽水灌胃，每日一次，連續18天。檢測指標為巨噬細胞吞噬功能。</p>
              <p>結果顯示：冬蟲夏草組吞噬指數明顯高於對照組（P
                &lt;0.05)） ,且冬蟲夏草高、中低三個劑量組之間比較統計學意義顯著（P&lt;0.05），隨冬蟲夏草劑量的增大，吞噬指數有增高趨勢。研究者分析，雖然冬蟲夏草滋補強身的作用機制是多方面的，但增強機體免疫功能在其中可能是重要方面之一。</p>
                  <p>冬蟲夏草水提物對巨噬細胞吞噬功能的實驗研究 . 山西醫科大學學報，2000，31（1）.</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《胎兒角膜移植術及排斥反應防治》結果顯示：</p>
            <h4>冬蟲夏草能強化免疫抑製作用，降低角膜移植術後的排斥反應，提高移植片透明率</h4>
            <p>移植後角膜的透明率、排斥反應發生率以及術後視力恢復情況對比</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab6.jpg" alt="">
            </div>
            <div>
              <p>角膜移植術是挽救視力、治療角膜病的有效措施之一。然而成人供體角膜來源極端缺乏；而且，器官移植後的免疫排斥反應是一種組織相容性抗原不符引起的遲發性特異性細胞免疫反應，反應高峰在術後1-3個月內。單用有關西藥減輕或控制排斥反應，臨床效果多不滿意。本研究採用≥7月齡引產胎兒角膜作供體手術治療角膜病42例，隨機分為對照組20例，在術後採用每日換藥，散瞳、抗生素和皮質類固醇滴眼，全身使用皮質類固醇；冬蟲夏草組22例，除對照組的常規治療外，加​​用冬蟲夏草每日口服。療程均為1.5-2個月。</p>
              <p>研究觀察移植後角膜的透明率、排斥反應發生率以及術後視力恢復情況。</p>
              <p>結果顯示：冬蟲夏草組移植角膜的透明率明顯高於對照組；冬蟲夏草組排斥反應在術後5-6週發生，其發生率為13.64％，而對照組排斥反應在5-9週均有發生，發生率為45％。術後隨訪視力恢復情況，冬蟲夏草組視力≥0.3的68.18%，對照組僅為35%。</p>
              <p>研究證實冬蟲夏草能強化免疫抑製作用，降低排斥反應，提高移植片透明率。</p>
              <p>胎兒角膜移植術及排斥反應防治 . 眼外傷職業眼病雜誌，1998，20（4）.</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《蟲草多醣對OVA過敏性哮喘鼠氣道炎症和氣道高反應的影響》結果顯示：</p>
            <h4>1. 冬蟲夏草多醣能減輕哮喘患者的症狀和改善通氣，發揮抗哮喘作用</h4>
            <p>冬蟲夏草多醣降低哮喘氣道高反應</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab7.jpg" alt="">
            </div>
            <div>
              <p>過敏性哮喘是一種以嗜酸性粒細胞為主的多種炎症細胞浸潤、炎症介質和細胞因子參與的慢性氣道炎症性疾病。活化的嗜酸性粒細胞可釋放多種物質造成氣道上皮損傷、氣道反應性增高、黏液分泌增多，以及間歇性氣道阻塞。</p>
              <p>本實驗採用天然藥物化學方法從冬蟲夏草中提取出多醣成分並用於抗過敏性哮喘的研究。採用隨機表法將小鼠隨機等分成4組：正常對照組、哮喘組、地塞米松組和冬蟲夏草多醣組。除正常對照組外，其它三組均建立同樣的哮喘實驗模型，在誘導哮喘發作前30分鐘，地塞米松組給予地塞米松4毫克/千克體重，冬蟲夏草多醣組給予冬蟲夏草多醣100毫克/千克體重。</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《蟲草多醣對OVA過敏性哮喘鼠氣道炎症和氣道高反應的影響》結果顯示：</p>
            <h4>2.冬蟲夏草多醣能顯著改善哮喘氣道炎症，減少促炎因子的生成</h4>
            <p>冬虫夏草多糖抑制哮喘气道中嗜酸性粒细胞的增加</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro_tab8.jpg" alt="">
            </div>
            <div>
              <p>研究觀察肺功能、支氣管肺泡灌洗液嗜酸性粒細胞計數、鼠肺組織IL-4，IL-5，IL-13 檢測、肺組織病理改變。</p>
              <p>結果顯示：蟲草多醣治療能降低哮喘的氣道高反應（P
                &lt;0.05），效果與地塞米松治療組氣道反應性比較無差異；蟲草多醣治療組能顯著抑制嗜酸性粒細胞的增加（P &lt;0.05）；蟲草多醣治療組與地塞米松治療組，IL-4，IL-5，IL-13與哮喘組相比明顯減少。病理觀察發現，哮喘組氣道上皮不完整，纖毛脫落，黏膜下有大量嗜酸性粒細胞浸潤，氣道腔存在大量的黏性蛋白和杯狀細胞增生。蟲草多醣和地塞米松組上皮損傷、炎性細胞浸潤較輕，黏性蛋白和杯狀細胞增生較少見。</p>
                  <p>研究表明，冬蟲夏草多醣能顯著改善哮喘氣道炎症，減少促炎因子的生成，減輕哮喘患者的症狀和改善通氣，發揮抗哮喘作用。</p>
                  <p>蟲草多醣對OVA過敏性哮喘鼠氣道炎症和氣道高反應的影響 . 中國現代應用藥學，2011，28（12）.</p>
            </div>
          </div>
          <hr>
          <div class="flex">
            <ul class="ul_li">
              <li>冬蟲夏草對腦梗塞患者免疫功能影響的研究</li>
              <li>冬蟲夏草對抗體形成細胞的作用研究</li>
              <li>冬蟲夏草對小鼠淋巴細胞增殖和IL-2 產生的作用</li>
              <li>冬蟲夏草免疫增強作用機理的研究</li>
              <li>冬蟲夏草水提物對巨噬細胞吞噬功能的實驗研究</li>
              <li>冬蟲夏草抗炎免疫調節作用的研究進展</li>
              <li>冬蟲夏草粗多醣誘導小鼠腹腔巨噬細胞產生TNF-α 的作用</li>
            </ul>
            <ul class="ul_li" style="margin-left:auto;">
              <li>胎兒角膜移植術及排斥反應防治</li>
              <li>冬蟲夏草對人類嗜中性白血球活化影響研究</li>
              <li>冬蟲夏草在腎移植術後的應用</li>
              <li>蟲草多醣對OVA 過敏性哮喘鼠氣道炎症和氣道高反應的影響</li>
              <li>冬蟲夏草可減輕器官移植時的排異反應</li>
              <li>冬蟲夏草抗角膜移植排斥反應實驗研究的初步報告</li>
              <li>冬蟲夏草提取物的免疫抑制功能</li>
            </ul>
          </div>
        </div>
        <!--<div><img src="../../assets/advertisement/introduceFour/z_effect3.jpg" alt=""></div>-->
        <div v-if="part[2].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">3、 預防與直接抗腫瘤作用，協同放化療效果、減輕毒副作用</h4>
          <div class="red-h4">
            <h4>預防惡性腫瘤的發生</h4>
            <h4>腫瘤的輔助治療與放、化療的增效減毒</h4>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草抗小鼠艾氏腹水癌的研究》結果顯示：</p>
            <h4>冬蟲夏草能減少腫瘤發生率，延長帶瘤生存期，且劑量越高，效果越好</h4>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab1.jpg" alt="">
            </div>
            <div>
              <p>本研究按全國抗癌藥物協作會議統一的抗癌藥物篩選方法，每隻鼠腹腔接種活癌細胞約50萬個，再隨機分配。</p>
              <p>第一批，接種後24小時開始給予冬蟲夏草提取物治療，每天一次，連續15次；接種後不給藥的設為對照組，按每日給予的冬蟲夏草提取物用量分為三個劑量組：0.355克/千克體重、0.71克/千克體重、1.42克/千克體重。第二批先給予冬蟲夏草提取物1.42克/千克體重， 每天一次，連續5天，然後再接種腫瘤，於接種24小時後，再每夭給予冬蟲夏草提取物一次, 連續10天；仍以不給藥的設為對照組。</p>
              <p>研究觀察至接種腫瘤後60天結束，對60天尚存活的動物處死解剖觀察其是否帶實體瘤。療效統計為兩種：60天各組動物未發瘤百分率；各組動物死亡情況、平均生存天數，與對照組比較計算其生存延長率。</p>
              <p>研究結果表明：接種腫瘤細胞後給藥的，冬蟲夏草提取物對艾氏腹水癌，在0.355克/千克體重×15天的劑量下即有明顯的抑製作用。隨著劑量的提高，其抑製作用更為明顯，且生存延長率也極顯著提高（P
                &lt;0.001)。接種前5天開始給藥的，也顯示冬蟲夏草提取物對艾氏腹水癌有明顯的生存延長作用。</p>
                  <p>冬蟲夏草抗小鼠艾氏腹水癌的研究 . 北京醫學1981，3（6）</p>
            </div>
          </div>

          <div class="title-tip">
            <p>《冬蟲夏草抗喉癌的研究》結果顯示：</p>
            <h4>冬蟲夏草對喉癌細胞增殖性生長有明顯的抑製作用，且劑量越高、時間越長，效果越好</h4>
            <p>喉癌細胞數（x10<sup style="font-size: 8px;">4</sup>）隨用藥時間的變化</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab2.jpg" alt="">
            </div>
            <div>
              <p>本实验利用体外细胞培养技术、参照美国国立癌症研究所体外药物筛选标准，检测冬虫夏草对人喉癌细胞的作用。</p>
              <p>实验观察两项指标：生长曲线计数、喉癌细胞克隆形成。</p>
              <p>结果显示：冬虫夏草组喉癌细胞的存活与对照组相比差异显著<br>（P
                &lt; 0.05），从生长曲线可见，冬虫夏草高浓度组比低浓度组抑制癌细胞存活明显增强 （P&lt; 0.05），随着冬虫夏草作用时间增长存活的喉癌细胞有减少，故认为冬虫夏草对治疗喉癌有效，且研究发现，冬虫夏草是浓度依赖性药物，时间依赖性次之，使用冬虫夏草时首先要考虑给药的浓度，即在用量允许范围内尽可能采用高浓度、尽量提高“浓度×时间”值，充分显示药物的活性。</p>
                  <p>从克隆形成试验结果可见，喉癌细胞的克隆形成率随冬虫夏草的浓度增加有明显下降，在冬虫夏草水提物稀释度为1：100时克隆形成抑制率&gt;50％，参照NCI体外药物筛选标准 ，ED<sub style="font-size: 10px">50</sub>（半数有效浓度：抑制对照增殖50% 浓度）
                    &lt; 1:100稀释度为敏感，故喉癌细胞对冬虫夏草敏感。</p>
                      <p>本试验初步证明中药冬虫夏草对喉癌细胞的增殖性生长有直接抑制作用。</p>
                      <p>冬虫夏草抗喉癌的研究. 白求恩医科大学学报，1993，19（1）.</p>
            </div>
          </div>

          <div class="title-tip">
            <p>《冬蟲夏草提取液抑制結腸癌細胞增殖的研究》結果顯示：</p>
            <h4>冬蟲夏草可以有效的抑制結腸癌細胞的增殖，藥物濃度越大，抑製作用越強</h4>
            <p>結腸癌細胞數（×10<sup style="font-size:8px;">4</sup>）</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab3.jpg" alt="">
            </div>
            <div>
              <p>本實驗觀察冬蟲夏草提取液對體外培養的人結腸癌細胞株HT-29、SW480的抑制效應，並利用報告基因技術初步探明冬蟲夏草發揮抑製作用的機制。</p>
              <p>研究對兩種結腸癌細胞株進行體外培養，加入不同濃度的冬蟲夏草提取液干擾，檢測對腫瘤細胞增殖的抑製作用。利用報告基因技術，檢測SW480細胞內NF-κB（核因子κB，能促進腫瘤發育）相對活性，觀察冬蟲夏草對細胞NF-κB活性的影響。</p>
              <p>結果顯示：冬蟲夏草可以有效的抑制兩種結腸癌細胞的增殖，並具有良好的劑量一效應關係。在作用濃度為1:160-1:10範圍內，冬蟲夏草對兩種結腸癌細胞株增殖均有抑製作用，濃度為1:10抑製作用最顯著，而當作用濃度為1:160時，抑製作用較弱，同空白對照組相比沒有統計學差異。這表明，在實驗的濃度範圍內，冬蟲夏草抑制結腸癌細胞增殖的能力與冬蟲夏草濃度密切相關，藥物濃度越大，抑製作用越強。同時，報告基因檢測結果表明冬蟲夏草可以抑制NF-κB活性，並通過這種作用抑制結腸癌細胞增殖。</p>
              <p>冬蟲夏草提取液抑制結腸癌細胞增殖的研究. 中藥材，2007，30（3）.</p>
            </div>

          </div>
          <div class="title-tip">
            <p>《中藥冬蟲夏草對白細胞減少症的療效分析》結果顯示：</p>
            <h4>冬蟲夏草可以減輕放、化療的反應，有效治療白細胞減少症</h4>
            <p>服藥後白細胞數比服藥前增加數量（細胞數/mm<sup style="font-size:8px;">3</sup>）</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab4.jpg" alt="">
            </div>
            <div>
              <p>白細胞減少症是一種頗為常見的慢性疾病。其臨床表現為頭暈、乏力、食慾不振、心悸、失眠並易患感冒。特別是癌症患者在放、化療過程中出現的白細胞減少，是最常見的不良反應。根據本病的表現，中醫歸屬於“虛勞”“血症”的範疇，臨床較為難治。西醫用維生素B4、利血生及激素藥物等治療，有一定療效，但停藥後，白細胞往往重新跌落。近年來，中醫臨床以補脾益腎、益氣補腎、活血等方法治療白細胞減少症效果很好。</p>
              <p>本研究將病人分為對照組（採用常規治療：口服利血生20mg，維生素B410 mg，3次/天）和冬蟲夏草組（常規治療+冬蟲夏草6克/天)，連續服用8週。觀察治療前後白細胞計數的變化和不良反應。</p>
              <p>結果顯示：冬蟲夏草組白細胞的增長與對照組比較有顯著性差異，且冬蟲夏草組患者的不適症狀（乏力、食慾不振、反复感冒等），明顯得到改善，無不良反應。</p>
              <p>臨床實踐證明，冬蟲夏草對於治療血液病之白細胞減少症，腫瘤放、化療所致的白細胞減少及各種原因引起的白細胞減少，均有明顯的提升作用。一般1-2週即可見效，而且藥效持久，無不良反應。</p>
              <p>中藥冬蟲夏草對白細胞減少症的療效分析. 中國實用醫藥，2009，4（9）.</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草對順鉑所致腎損害保護的臨床觀察》結果顯示：</p>
            <h4>冬蟲夏草對化療藥物順鉑引起的腎損害有明顯的改善作用</h4>
            <p>冬蟲夏草組總有效率（95.2%）明顯高於對照組（71.4%）</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab5.jpg" alt="">
            </div>
            <div>
              <p>順鉑作為一種最常用的化療藥，不論單用，還是和其他藥物聯用，部分病人會出現藥物性腎損害，一般腎損害發生在用藥後7-12天，經積極治療後可於1個月左右恢復，否則病情發展，將會導致氮質血症、尿毒症，甚則危及生命。腫瘤患者通常發現病情時就已經出現機體臟腑功能的損害, 再加上藥物尤其是化療藥的副作用，肝腎等臟器的損害尤為明顯。</p>
              <p>本研究選擇直腸癌、大腸癌、肺癌、惡性淋巴瘤患者、以順鉑為主的化療病人，隨機分為常規治療組和加用冬蟲夏草組（3克/天）。化療後腎小管的損傷及腎功能的損害主要是通過測定尿NAG 酶、尿微球蛋白（β2-MG） 、血尿素（BUN） 與血肌酐（Cr） 指標觀察。療效評價分三級。顯效：指標全部正常，堅持服藥連續化療過程中以上化驗指標亦未見異常升高；有效：指標改善，堅持服藥連續化療過程中以上化驗指標部分見異常升高；無效：指標無改善,堅持服藥連續化療過程中以上化驗指標見異常升高。</p>
              <p>結果顯示：冬蟲夏草組在保護腎功能方面明顯優於常規治療組，兩組總有效率比較有顯著性差異（P
                &lt;0.05) 。</p>
                  <p>研究專家結合冬蟲夏草現代研究結果分析，冬蟲夏草在腎臟保護方面，主要是增加及重新分佈腎組織表皮生長因子, 加速腎小管修復，明顯減輕急性腎小管損害程度，促使腎衰患者的腎功能儘早恢復。</p>
                  <p>冬蟲夏草對順鉑所致腎損害保護的臨床觀察. 江蘇中醫藥，2003，24（12）.</p>
            </div>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab6.jpg" alt="">
            </div>
            <div class="title-tip">
              <p>《冬蟲夏草對白血病NK細胞影響的體外研究》結果顯示：</p>
              <h4>冬蟲夏草對正常人及白血病患者NK細胞活性具有明顯的增強作用，且呈劑量-效應依賴性</h4>
              <p>1、冬蟲夏草對正常人及白血病NK細胞活性均具有明顯的增強作用</p>
            </div>
          </div>
          <div class="title-tip">
            <h4>2、冬蟲夏草對正常人及白血病NK細胞活性的增強作用，均隨濃度增加而增大</h4>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro3_tab7.jpg" alt="">
            </div>
            <div>
              <p>自然殺傷細胞（NK）是機體重要的免疫細胞，與抗腫瘤能力密切相關。 NK細胞作為機體免疫監視的第一道防線，與白血病的發生髮展有重要關係，提高白血病患者NK細胞活性，可能對改善白血病的緩解率、延長生存期有重要意義。</p>
              <p>本研究採用單克隆抗體及效靶細胞結合試驗觀察冬蟲夏草對正常人及白血病患者外周血細胞的影響。將冬蟲夏草水提液500mg/ml，依次按1:1、1:2、1:4、1:8、1:16稀釋，加入細胞培養液中，孵育後檢測NK細胞活性。</p>
              <p>結果顯示：冬蟲夏草對正常人及白血病患者NK細胞活性具有明顯的增強作用（P
                &lt;0.01），且呈劑量-效應依賴性（濃度越大效果增強）。</p>
                  <p>研究認為，冬蟲夏草作為生物反應調節劑用於急性白血病治療以提高NK細胞活性，值得進一步研究、開發與利用。</p>
                  <p>冬蟲夏草對白血病NK細胞影響的體外研究. 中國中西醫結合雜誌，1992，12（5）.</p>
            </div>
          </div>

          <hr>
          <div class="flex">
            <ul class="ul_li">
              <li>冬蟲夏草對白血病人NK 和LAK 細胞活性的影響</li>
              <li>冬蟲夏草對腫瘤患者紅細胞天然免疫粘附腫瘤細胞的增強作用</li>
              <li>冬蟲夏草對乳腺癌細胞凋亡的誘導及相關基因表達的調控</li>
              <li>冬蟲夏草抗喉癌的研究</li>
              <li>蟲草素及蟲草多醣對結直腸癌轉移的預防作用和調控血管內皮生長因子表達的研究</li>
            </ul>
            <ul class="ul_li" style="margin-left:auto;">
              <li>冬蟲夏草提取液抑制結腸癌細胞增殖的研究</li>
              <li>冬蟲夏草對白血病NK 細胞影響的體外研究</li>
              <li>中藥冬蟲夏草對白細胞減少症的療效分析</li>
              <li>冬蟲夏草對順鉑所致腎損害保護的臨床觀察</li>
              <li>冬蟲夏草對H22 肝癌小鼠化療後免疫功能的影響</li>
              <li>冬蟲夏草合用順鉑誘導非小細胞肺癌凋亡的研究</li>
            </ul>
          </div>
        </div>
        <div v-if="part[3].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">4、 抗自由基、抗氧化，抗衰老，增強記憶力</h4>
          <div class="red-h4">
            <h4>預防疾病，延緩衰老，改善亞健康狀態</h4>
            <h4>改善酸性體質，促進運動後恢復</h4>
            <h4>增強記憶力，延緩腦老化</h4>
          </div>

          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro4_tab1.jpg" alt="">
            </div>
            <div class="title-tip">
              <p>《冬虫夏草提取物延缓衰老实验研究》结果显示：</p>
              <h4>1. 冬虫夏草能有效提高衰老动物的学习记忆能力</h4>
              <p>冬虫夏草缩短衰老动物水迷宫游泳时间（秒）</p>
            </div>
          </div>
          <div>
            <h4>2. 冬蟲夏草能通過提高抗氧化酶活性、清除自由基、減少過氧化脂質的生成，起到延緩衰老作用</h4>
            <p>冬蟲夏草提高衰老小鼠腦中超氧化物歧化酶的濃度，降低單胺氧化酶水平</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro4_tab2.jpg" alt="">
            </div>
            <div>
              <p>衰老是分子、细胞、器官功能乃至整个功能衰退的综合复杂的生理、病理变化过程。机体在细胞代谢过程中不断产生的自由基，具有极强的氧化能力，能使机体内多种生物大分子变性、断裂，引起细胞结构和功能的破坏，而导致机体的衰老。目前临床上常用维生素E、维生素C、褪黑素、微量元素硒等药物预防和治疗衰老相关疾病，它们的作用大多单一，不能全面改善机体的衰老体征，而中药则因其能从综合调理的高度增强人体机能、提高抗病能力而越来越受到人们的青睐。</p>
              <p>本实验观察冬虫夏草提取物对实验性衰老小鼠的抗衰老作用及机制。将小鼠分为6组：正常对照组，衰老模型（对照）组，冬虫夏草高（4.0克/千克体重）、中（2.0克/千克体重）、低（1.0克/千克体重）三个剂量组，VC组（50毫克/千克体重）。在给药6周后，对动物进行学习记忆测试，测定超氧化物歧化酶、谷胱甘肽过氧化物酶、过氧化氢酶，大脑中的单胺氧化酶 、Na+-K+-ATP酶、过氧化脂质的分解产物丙二醛指标的含量变化，观察冬虫夏草的抗衰老作用。</p>
              <p>结果显示：冬虫夏草能有效提高衰老动物的学习记忆成绩，不同程度提高衰老小鼠肝、脑、红细胞的超氧化物歧化酶、谷胱甘肽过氧化物酶、过氧化氢酶活性，提高脑中Na+-K+-ATP酶活性，降低脑中单胺氧化酶活性，降低肝、脑中过氧化脂质的分解产物丙二醛的含量。</p>
              <p>研究证实冬虫夏草能有效防止多项衰老体征的出现，具有明显的延缓衰老作用，其作用机理可能与其提高抗氧化酶活性、清除自由基、减少过氧化脂质的生成有关。</p>
              <p>冬虫夏草提取物延缓衰老实验研究 . 中国中药杂志，2004，29（8）.</p>
            </div>
          </div>
          <hr>
          <div class="flex">
            <ul class="ul_li">
              <li>冬蟲夏草對大鼠運動能力的影響</li>
              <li>冬蟲夏草對運動小鼠肝組織自由基代謝及血清酶活性的影響</li>
              <li>蟲草菌多醣對吸煙引起的樹突狀細胞氧化損傷的保護作用</li>
              <li>蟲草胞外多醣延緩果蠅衰老暨減輕香煙毒害作用的研究</li>
            </ul>
            <ul class="ul_li" style="margin-left:auto;">
              <li>冬蟲夏草提取物延緩衰老實驗研究</li>
              <li>神奇的滋補中藥-- 冬蟲夏草</li>
              <li>冬蟲夏草的滋補藥膳方</li>
              <li>老人養生冬蟲夏草有奇效</li>
            </ul>
          </div>
        </div>
        <div v-if="part[4].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">5、 提高細胞能量、促進機體損傷修復，抗缺氧、抗疲勞</h4>
          <div class="red-h4">
            <h4>改善亞健康狀態</h4>
            <h4>延緩衰老</h4>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草的抗疲勞作用研究》結果顯示：</p>
            <h4>冬蟲夏草具有抗疲勞作用，可增強機體對運動耐力的適應性和保護作用</h4>
            <p>冬蟲夏草延長負重游泳時間，降低運動產生的乳酸及尿素氮</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro5_tab1.jpg" alt="">
            </div>
            <div>
              <p>运动时无氧代谢产生乳酸，会破坏内环境的稳定性， 影响心血管系统、骨骼肌系统功能的正常发挥，导致疲劳的产生， 因此及时清除体内乳酸对于疲劳的消除有积极的作用；血清尿素氮含量可反映体内蛋白质分解情况，当能量供应不足可导致肌肉蛋白质分解以供能，但是蛋白质作为身体的框架结构成分, 其被分解破坏必然会导致正常生物学功能的正常发挥受影响，影响肌肉的收缩，表现出疲劳等症状。</p>
              <p>本实验将实验小鼠分为四组：对照组，冬虫夏草低（0.25克/千克体重）、中（0.5克/千克体重）、高（1.0克/千克体重）三个剂量组。进行负重游泳试验（游泳实验能从整体上反映受试物对动物耐力的影响，是对各个系统综合作用的反映）、血清乳酸和尿素氮的测定。</p>
              <p>结果显示：冬虫夏草中、高剂量可延长小鼠负重游泳时间，高剂量可明显降低游泳后血乳酸含量。低、中、高剂量均可降低游泳后血清尿素氮的含量。</p>
              <p>研究证实冬虫夏草达到一定剂量时具有抗疲劳作用，可增强机体对运动耐力的适应性和保护作用。</p>
              <p>冬虫夏草的抗疲劳作用研究 . 湖北预防医学杂志，2000,11（1）</p>
            </div>
          </div>

          <hr>
          <div class="flex">
            <ul class="ul_li">
              <li>蟲草抗運動性疲勞實驗研究</li>
              <li>冬蟲夏草的抗疲勞作用研究</li>
              <li>冬蟲夏草抗小鼠運動性疲勞的作用及機制研究</li>
              <li>冬蟲夏草對阿黴素心肌損傷的保護作用</li>
              <li>冬蟲夏草提取液對糖尿病小鼠肝線粒體氧化磷酸化功能保護作用</li>
            </ul>
          </div>
        </div>
        <div v-if="part[5].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">6、調節血糖、保護胰腺β細胞、促進機體對糖的利用</h4>
          <div class="red-h4">
            <h4>改善糖耐量異常與糖尿病患者的糖代謝</h4>
          </div>
          <div class="flex">
            <div>
              <div>
                <p>《冬蟲夏草提取物對模型大鼠血糖及氧化應激的影響》結果顯示：</p>
                <h4>冬蟲夏草可降低糖尿病模型動物的血糖、糖化血清蛋白，改善體內異常的氧化應激水平</h4>
                <p>1、冬虫夏草可降低糖尿病模型动物的血糖</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro6_tab1.jpg" alt="">
              </div>
              <div>
                <p>2、冬蟲夏草降低糖尿病模型動物的糖化血清蛋白水平（mmol/L)，抑制誘生型一氧化氮合酶（U/L）的表達</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro6_tab2.jpg" alt="">
              </div>
            </div>
            <div>
              <p>糖尿病患者體內存在著明顯的氧化應激現象。糖尿病的發生、發展與機體的氧化損傷，以及抗氧化防禦系統清除自由基能力下降密切相關。其中，誘生型一氧化氮合酶過度表達可以產生大量的一氧化氮，過量的一氧化氮可以通過直接的細胞毒作用和誘導繼發性毒物引起細胞的氧化應激損傷，最終造成細胞功能的損害。</p>
              <p>本實驗將實驗用糖尿病大鼠分為六組：正常對照組、糖尿病組，二甲雙胍組（0.2克/千克體重）、冬蟲夏草提取物低（0.5克/千克體重）、中（1.0克/千克體重） 、高（1.5克/千克體重）三個劑量組，連續給藥8週，測定空腹血糖及糖化血清蛋白，血清和肝臟中的超氧化物歧化酶、穀胱甘肽過氧化物酶活性及丙二醛含量變化，檢測血清中一氧化氮、總一氧化氮合酶、誘生型一氧化氮合酶和結構型一氧化氮合酶的含量。</p>
              <p>結果顯示：冬蟲夏草中、高劑量能夠降低糖尿病大鼠空腹血糖（P
                &lt;0.05）和糖化血清蛋白（P&lt;0.05）；冬蟲夏草各劑量組均能提高血清和肝臟的超氧化物歧化酶、穀胱甘肽過氧化物酶水平（P&lt;0.05），降低脂質過氧化物產物丙二醛的含量。與糖尿病組比較，冬蟲夏草中、高劑量組血清一氧化氮、誘生型一氧化氮合酶均明顯下降。</p>
                  <p>研究證實冬蟲夏草可降低糖尿病模型動物的血糖、糖化血清蛋白，提高血清和肝臟超氧化物歧化酶活性，降低丙二醛含量，改善體內異常的氧化應激水平，降低血清一氧化氮含量可能是通過抑制誘生型一氧化氮合酶的表達實現。</p>
                  <p>冬蟲夏草提取物對模型大鼠血糖及氧化應激的影響 .中國中醫藥信息雜誌，2012,19（12）</p>
            </div>
          </div>
          <div>
            <p>《冬蟲夏草治療糖尿病腎病90例臨床分析》結果顯示：</p>
            <h4>冬蟲夏草能有效減少早期糖尿病腎病尿白蛋白漏出，對延緩早期糖尿病腎病的進展有顯著療效</h4>
            <p>冬蟲夏草組尿白蛋白（mg/24h）在治療6個月時開始明顯減少</p>
          </div>
          <div class="flex">


            <div>
              <img src="../../assets/advertisement/introduceFour/pro6_tab3.jpg" alt="">
            </div>

            <div>
              <p>糖尿病腎病是糖尿病全身性微血管合併症之一，因其導致尿毒症死亡者約佔糖尿病人的27-31%，糖尿病人一旦發生腎臟損害，出現持續尿蛋白則病情不可逆轉，往往進行性發展至終末期腎功能衰竭。臨床研究已經表明，在糖尿病腎病早期如果能夠減少尿白蛋白漏出，對延緩糖尿病腎病的進展與惡化有重要的意義。</p>
              <p>本臨床研究選擇了181例糖尿病腎病患者，其中處於腎功能不全代償期（GFR≥70ml/min，早期）研究組的64例患者分為常規治療組32例和冬蟲夏草組32例；處於腎功能失代償期（GFR
                &lt;70ml/min，中晚期）研究組的117例，分為常規治療組59例，冬蟲夏草組58例。治療方法：冬蟲夏草組每日服用冬蟲夏草2克。所有病例均以飲食、運動療法結合糖適平、拜糖平及胰島素，血管緊張素轉換酶抑製劑、鈣通道阻滯劑及利尿劑等，控製糖化血紅蛋白與血壓。</p>
                  <p>所有患者於治療後1個月，6個月，12個月時檢測尿白蛋白、腎功能各項指標；腎功能失代償期患者復測腎小球濾過率。 24例（對照組8例，治療組16例）患者分別在開始治療時及1年後行B超下腎活檢穿刺術取腎臟組織病理學檢查。</p>
                  <p>結果顯示：腎功能不全代償期患者，冬蟲夏草組在6個月時效果與常規治療組相比已經有統計學差異，12個月時有顯著差異；腎功能失代償期患者，兩組比較無顯著性差異；病理學檢查顯示：12個月後，24例患者腎小球硬化數量均有增加，冬蟲夏草組比常規治療組有所減輕，提示冬蟲夏草可減輕腎小球肥大及系膜增殖。</p>
                  <p>研究證實冬蟲夏草能有效減少早期糖尿病腎病尿白蛋白漏出，對延緩早期糖尿病腎病的進展有顯著療效，且能夠減輕腎臟的病理改變，延緩慢性腎衰的進展。</p>
                  <p>冬蟲夏草治療糖尿病腎病90例臨床分析 . 臨床醫學，2000，20（1）</p>
            </div>
          </div>

          <div class="title-tip">
            <p>《冬蟲夏草對糖尿病腎病大鼠醣脂代謝紊亂的影響》結果顯示：</p>
            <h4>冬蟲夏草能有效改善糖、脂代謝紊亂</h4>
            <p>各組血糖、血脂指標的比較（單位mmol/L）</p>
          </div>

          <div class="flex">


            <div>
              <img src="../../assets/advertisement/introduceFour/pro6_tab4.jpg" alt="">
            </div>

            <div>
              <p>糖代謝異常對糖尿病腎病的發生、發展具有重要的影響，脂代謝紊亂可加速、加重糖尿病的腎臟損害。</p>
              <p>本研究中將Wistar大鼠隨機分為正常對照組10只和實驗組（糖尿病腎病模型）40只，再將實驗組動物分為模型對照組（有糖尿病腎病但不予用藥），冬蟲夏草高劑量組（6克/千克體重），冬蟲夏草低劑量組（3克/千克體重），治療8週後，測定尿蛋白排泄量，血總膽固醇（TC）、甘油三酯（TG）、低密度脂蛋白（ LDL）、高密度脂蛋白（HDL）、血肌酐、空腹血糖。</p>
              <p>結果顯示：與模型對照組比較，冬蟲夏草高、低劑量組大鼠膽固醇、甘油三酯、低密度脂蛋白均顯著降低（P
                &lt;0.01）。血糖雖有下降，但差異不顯著。</p>
                  <p>研究證明，冬蟲夏草可以有效地改善糖、脂代謝紊亂，從而延緩和阻止糖尿病腎臟損害，防治糖尿病腎病。</p>
                  <p>冬蟲夏草對糖尿病腎病大鼠醣脂代謝紊亂的影響，牡丹江醫學院學報，2008（3）。</p>
            </div>
          </div>
          <hr>
          <ul class="ul_li">
            <li>冬蟲夏草提取物對模型大鼠血糖及氧化應激的影響</li>
            <li>冬蟲夏草對糖尿病腎病大鼠醣脂代謝紊亂的影響</li>
            <li>冬蟲夏草藥理學作用的研究進展</li>
          </ul>
        </div>
        <div v-if="part[6].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">7、調節呼吸系統功能</h4>
          <div class="red-h4">
            <h4>鎮咳、袪痰、平喘</h4>
            <h4>防治習慣性感冒、呼吸道反复感染或過敏</h4>
            <h4>改善肺功能，延緩肺纖維化，干預慢性阻塞性肺病的進展</h4>
            <h4>提高肺結核的療效，配合化療增效減毒，保護肝腎功能</h4>
          </div>
          <div class="title-tip">
            <p>《单味冬虫夏草防治56例老年患者反复呼吸道感染疾病临床观察》结果显示 ：</p>
            <h4>冬虫夏草用于防治反复呼吸道感染疾病有良好效果</h4>
            <p>冬虫夏草治疗组总有效率明显高于对照组</p>
          </div>
          <div class="flex">

            <div>
              <img src="../../assets/advertisement/introduceFour/pro7_tab1.jpg" alt="">
            </div>
            <div>
              <p>老年反复呼吸道感染疾病主要由年老體衰、免疫功能低下、抗病屏障破壞造成，中醫認為是肺腎不足，冬蟲夏草具有溫腎補肺功效。本研究觀察了冬蟲夏草對老年反复呼吸道感染疾病的防治效果。</p>
              <p>研究將老年反复呼吸道感染患者隨機分為冬蟲夏草湯劑組30例、冬蟲夏草粉劑組26例、對照組24例。湯劑組冬蟲夏草每週2次，10克/次；冬蟲夏草粉劑組每日3克研成粉末服用；對照組服用左旋咪唑0.3克/週。均2個月為一療程。以發病次數、病程長短、病種（上呼吸道感染、支氣管炎、支氣管肺炎）為依據進行病情分級及療效評定（顯效、有效、無效），並在治療前後檢查IgG、IgA、IgM、C3以作對比。</p>
              <p>結果顯示： 冬蟲夏草治療組（湯劑、粉劑）有效率分別為93.3%、92.3%，均明顯優於對照組70.9%，P
                &lt;0.01；且冬蟲夏草治療組患者免疫指標提高顯著高於對照組，P &lt;0.05。</p>
                  <p>研究證實冬蟲夏草用於防治反复呼吸道感染疾病有良好效果。</p>
                  <p>單味冬蟲夏草防治56例老年患者反复呼吸道感染疾病臨床觀察. 福建醫藥雜誌，1999，21（3）</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《蟲草對兒童哮喘患者細胞免疫功能的影響》結果顯示：</p>
            <h4>冬蟲夏草輔助治療兒童哮喘效果好，安全性高，副作用少</h4>
            <p>冬蟲夏草組近期控制（無發作、體徵、肺功能正常）、總有效率（95%）明顯優於對照組（80%）</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro7_tab2.jpg" alt="">
            </div>
            <div>
              <p>支氣管哮喘是兒童時期最常見的呼吸道慢性疾病之一，是由多種細胞和細胞組分共同參與的氣道慢性炎症性疾患。近年研究發現，哮喘存在T細胞免疫功能紊亂，T細胞的輔助與抑制功能失調。故通過應用免疫調節劑或免疫增強劑預防呼吸道感染對哮喘的防治起重要作用。</p>
              <p>本研究選擇已經經規範化治療後支氣管哮喘急性發作已緩解的患兒80例。隨機分為冬蟲夏草組和常規治療組各40例。常規治療組按《兒童哮喘防治常規》的方法堅持規則地使用糖皮質激素吸入、避免觸發因素等。冬蟲夏草組在常規治療基礎上，每週加用冬蟲夏草2-3克，連用3個月為一療程。</p>
              <p>觀察患兒的症狀（咳、痰、喘）、體徵（哮鳴音）、肺功能（PEF≥85％屬正常）、不良反應及外周血T細胞亞群等。</p>
              <p>療效標準：近期控制：無症狀、體徵，肺功能正常；有效：仍有發作，但發作的次數、程度明顯改善；無效：用藥3個月後發作的次數、程度無變化或較前加重。</p>
              <p>結果顯示：冬蟲夏草組總有效率95%，顯著高於常規治療組80%，P
                &lt;0.05。且冬蟲夏草組治療前後患兒的CD3、CD4、CD4/CD8、NK-A明顯升高，P&lt;0.01。</p>
                  <p>研究證明，應用冬蟲夏草輔佐治療效果好，安全性高，副作用少，與降低氣道炎症反應同時進行值得推廣。</p>
                  <p>蟲草對兒童哮喘患者細胞免疫功能的影響. 浙江中西醫結合雜誌，2006，16（1）</p>
            </div>
          </div>
          <div class="titlet">
            <p>《冬蟲夏草輔助治療復治肺結核》結果顯示：</p>
            <h4>冬蟲夏草有效提高複治肺結核的治愈率</h4>
            <p>冬蟲夏草組治愈率、總有效率均明顯優於對照組</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro7_tab3.jpg" alt="">
            </div>
            <div>
              <p>復治肺結核多由於不規則抗癆或病人免疫力低下而致，患者常缺乏協助抗結核藥物殺滅半休眠菌群或休眠菌群的免疫反應，導致單純抗結核藥物治療無法徹底殺滅體內的結核菌，而導致肺結核遷延不愈、病情纏綿。</p>
              <p>本研究將87例復治性肺結核病人隨機分為單純抗癆組（42例，單用抗癆藥）和冬蟲夏草組（45例，冬蟲夏草2克/日，加味對症中藥配以抗癆藥），連續服用9個月，週期性予以胸片及痰菌檢查。療效標準參照《全國結核病防治工作手冊》標準分為治愈、好轉、無好轉。</p>
              <p>結果顯示：冬蟲夏草組總有效率（93.3%）明顯高於單純抗癆組（81%）。兩組療效有極顯著性差異（χ2=91.959，P＜0.01）。</p>
              <p>冬蟲夏草輔助治療復治肺結核. 河南中醫，1999,19（5）</p>
            </div>
          </div>
          <hr>
          <ul class="ul_li">
            <li>蟲草對兒童哮喘患者細胞免疫功能的影響</li>
            <li>單味冬蟲夏草防治56 例老年患者反复呼吸道感染疾病臨床觀察</li>
            <li>冬蟲夏草治療肺間質病20 例臨床分析</li>
            <li>冬蟲夏草輔助治療復治肺結核</li>
            <li>冬蟲夏草輔助治療肺源性心髒病呼吸衰竭30 例療效觀察</li>
            <li>冬蟲夏草治療老年性咳喘1 例分析</li>
            <li>冬蟲夏草在呼吸系統疾病中的應用</li>
            <li>淺析蟲草在呼吸系統疾病治療中的臨床應用</li>
            <li>冬蟲夏草對COPD 模型大鼠肺功能及Th1/Th2 的影響</li>
            <li>冬蟲夏草預防肺纖維化的實驗研究</li>
          </ul>
        </div>
        <div v-if="part[7].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">8、 調節肝臟功能</h4>
          <div class="red-h4">
            <h4>保護肝臟，提高肝臟對有害物質如酒精的代謝能力</h4>
            <h4>減輕藥物性肝損害，保護肝功能</h4>
            <h4>修復肝損傷，改善脂肪肝、肝纖維化、延緩肝硬化的進程</h4>
            <h4>改善各種急、慢性肝炎患者的肝功能，促進乙肝病毒轉陰</h4>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草治療肝纖維化的臨床療效》結果顯示：</p>
            <h4>冬蟲夏草有良好的抗肝纖維化作用</h4>
            <p>治療前後肝纖維化各指標變化程度，冬蟲夏草組顯著優於對照組</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro8_tab1.jpg" alt="">
            </div>
            <div>
              <p>肝纖維化是由慢性肝病發展為肝硬化必經病理過程，大量資料提示此過程是可以逆轉的。肝纖維化尚無理想治療方法。許多作者試圖用抗肝纖維化藥物如秋水仙鹼、γ-干擾素、腎上腺皮質激素等控制病情或防止其發展為肝硬化，但由於藥物的毒副作用或價格昂貴，患者難以接受，效果亦不理想。</p>
              <p>本研究選擇肝纖維化患者49例，分為冬蟲夏草組（27例，冬蟲夏草3克/日）、對照組（22例，肌苷片1.2克/日，氟肝泰樂0.6克/日），療程均為3個月。</p>
              <p>治療前後分別抽血行血清III型前膠原（PCIII）及血清層粘連蛋白（LN）測定，並檢測谷丙轉氨酶（ALT）、膽紅素（SB）及白蛋白（ALB）變化，B超觀察肝纖維化圖像改變。對冬蟲夏草組4例、對照組2例在治療前後行肝穿刺檢查。</p>
              <p>結果顯示：冬蟲夏草組各項指標治療前後比較相差均非常顯著（P
                &lt;0.01）；對照組治療前後各項指標只有谷丙轉氨酶ALT有顯著差別（P&lt;0.01）；冬蟲夏草組與對照組治療後結果比較：白蛋白（ALB）、血清III型前膠原（PCIII）及血清層粘連蛋白（LN）治療後兩組有非常顯著的差異（P&lt;0.01）。</p>
                  <p>肝組織免疫組化及超微結構觀察結果顯示，冬蟲夏草能抑制肝竇週I、II、VI型膠原沉積，並能抑制儲脂細胞的轉化，改善肝細胞超微結構的損害。</p>
                  <p>研究提示冬蟲夏草有良好的抗肝纖維化作用。其機理可能是抑制儲脂細胞的功能，從而減少肝臟細胞外基質沉積。</p>
                  <p>冬蟲夏草治療肝纖維化的臨床療效 . 前衛醫學雜誌，1996，13（2）</p>
            </div>
          </div>
          <hr>
          <ul class="ul_li">
            <li>冬蟲夏草治療肝纖維化的臨床療效</li>
            <li>冬蟲夏草多醣治療慢性丙型肝炎患者的臨床研究</li>
            <li>冬蟲夏草* 黃芪對乙肝表面抗原陽性轉陰的研究</li>
            <li>蟲草多醣對大鼠肝星狀細胞核因子-κB 活性和腫瘤壞死因子-α 表達的影響</li>
            <li>冬蟲夏草對肝硬化大鼠谷丙轉氨酶和穀草轉氨酶的影響</li>
            <li>冬蟲夏草對大鼠實驗性肝纖維化的防治作用及其機理研究</li>
            <li>冬蟲夏草提取液對肝線粒體氧化磷酸化功能的影響</li>
          </ul>
        </div>
        <div v-if="part[8].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">9、 調節腎臟功能</h4>
          <div class="red-h4">
            <h4>防治藥物腎毒性損傷，保護腎功能，促進腎組織修復</h4>
            <h4>治療各種腎炎、腎病、腎小球硬化等，減少復發</h4>
            <h4>治療各種急、慢性腎功能不全，延緩病情進展</h4>
            <h4>促進骨髓造血機能，改善腎病患者貧血、血液凝固異常等症狀</h4>
            <h4>雙向調節免疫功能，抗腎臟移植後的排斥反應</h4>
          </div>

          <div class="flex">
            <div>
              <div class="title-tip">
                <p>《冬蟲夏草與西藥聯用治療蛋白尿38例》結果顯示</p>
                <h4>冬蟲夏草能夠有效減少蛋白尿</h4>
                <p>1、冬蟲夏草聯合治療組總有效率（71.1%）明顯高於西藥對照組（52.9%）</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro9_tab1.jpg" alt="">
              </div>
              <div class="title-tip">
                <p>2、冬蟲夏草聯合治療組對慢性腎炎、糖尿病腎病蛋白尿的有效率顯著高於西藥對照組</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro9_tab2.jpg" alt="">
              </div>
            </div>
            <div>
              <p>蛋白尿是很多疾病的常見症狀。腎小球性蛋白尿是由於腎小球結構變化或異常物質（如炎症、免疫反應產物）出現導致腎小球濾過膜受損而致。治療蛋白尿主要通過調節機體免疫，抑制免疫複合物的形成，改善腎臟的微循環，增加細胞的抗氧化能力等作用而達到目的。臨床上治療蛋白尿多采用中西醫結合的治療方式。</p>
              <p>本研究選擇慢性腎炎、糖尿病腎病、腎動脈硬化患者出現蛋白尿病例72例分為兩組，西藥對照組34例，每日口服保腎康、胰激肽釋放酶、雷公藤多甙片、維生素C、維生素E；冬蟲夏草聯合治療組38例，除應用上述西藥外，每日聯用1.5克-3克冬蟲夏草。 4個月為一療程，共用3個療程。</p>
              <p>觀察方法為每半月檢查尿常規，每1月測定24小時尿蛋白定量，每3月檢查腎功能。</p>
              <p>療效標準：顯效：經治療後24小時尿蛋白降至正常；有效：經治療後24小時尿蛋白明顯下降，但無法達到正常，波動在200-500mg之間；無效：經治療後24小時尿蛋白無變化或有增加者。</p>
              <p>結果顯示：冬蟲夏草聯合治療組療效明顯優於西藥對照組，兩組總有效率有顯著差異（P
                &lt;0.05）。且冬蟲夏草組對慢性腎炎、糖尿病腎病治療的有效率分別為85.7%和66.7%，顯著高於西藥對照組（65%、37.5%），P&lt;0.05。</p>
                  <p>研究證實，西藥與冬蟲夏草合用治療蛋白尿有很好的臨床應用價值。</p>
                  <p>冬蟲夏草與西藥聯用治療蛋白尿38例. 浙江中醫學院學報，1999，23（3）</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《冬蟲夏草對慢性腎功能衰竭T細胞亞群的影響》結果顯示：</p>
            <h4>冬蟲夏草能顯著改善慢性腎衰患者腎功能</h4>
            <p>服用冬蟲夏草前後腎功能指標的變化</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro9_tab3.jpg" alt="">
            </div>
            <div>
              <p>慢性腎功能衰竭患者易繼發感染，臨床統計佔80% 以上，如不積極處理，常可導致死亡。多數學者報告， 腎衰患者繼發感染的原因為免疫功能低下，主要是細胞免疫功能低下。而且，有研究發現，細胞免疫功能低下與血漿白蛋白（ ALb）及血紅蛋白（Hb）的降低密切相關。</p>
              <p>研究選擇慢性腎衰患者28例，每日服用冬蟲夏草3-5克，同時採用優質低蛋白飲食及一般內科保守治療，動態觀察10-12個月。對比服用冬蟲夏草前後腎功能的各項指標。</p>
              <p>結果顯示：冬蟲夏草組腎功能各項指標均有明顯改善（P
                &lt;0.05-0.01），白蛋白、血紅蛋白明顯升高，尿素氮、肌酐明顯降低，同時觀察到，冬蟲夏草可以提高腎衰患者的細胞免疫功能，且在應用中未見毒副作用。</p>
                  <p>研究證實，冬蟲夏草對延緩腎衰患者腎功能減退的發展，提高機體免疫力，預防繼發感染均大為有益。</p>
                  <p>冬蟲夏草對慢性腎功能衰竭T細胞亞群的影響. 中國中西醫結合雜誌，1992，12（6）</p>
            </div>
          </div>
          <div class="flex">
            <div>
              <div class="title-tip">
                <p>《冬蟲夏草應用於急性腎功能衰竭31例的臨床對照研究》結果顯示：</p>
                <h4>1. 冬虫夏草能通过促进坏死、损伤的肾小管上皮细胞修复，明显加快升高尿渗透压，改善肾小管浓缩、稀释功能</h4>
                <p>冬虫夏草联合治疗组与常规治疗组比较，禁水尿渗透压（mOsm/kg）第三周后明显上升</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro9_tab4.jpg" alt="">
              </div>
              <div class="title-tip">
                <h4>2. 冬蟲夏草能顯著促進尿NAG酶下降，修復腎小管上皮細胞，對急性腎功能衰竭有良好的防治作用</h4>
                <p>冬虫夏草联合治疗组与常规治疗组比较，尿NAG酶第二周后明显下降</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro9_tab5.jpg" alt="">
              </div>
              <div class="title-tip">
                <p>《冬蟲夏草治療單純性血尿的療效觀察》結果顯示：</p>
                <h4>冬蟲夏草能明顯提高血尿轉陰率</h4>
                <p>冬蟲夏草對單純性血尿轉陰的效果</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro9_tab6.jpg" alt="">
              </div>
            </div>
            <div>
              <p>急性腎功能衰竭（ARF）臨床上多見於腎毒性引起急性腎小管壞死，也包括腎小球疾病、腎血管病和間質病變，導致腎小球濾過率突然或持續下降，引起氮質廢物體內儲留，水、電解質和酸鹼平衡紊亂，所導致各系統並發症的臨床綜合徵。</p>
              <p>研究選擇了因魚膽中毒、慶大霉素腎毒性、流行性出血熱導致急性腎衰患者47例，分為常規治療組（16例，激素、利尿、抗感染等急性腎衰內科常規處理及血液透析治療），冬蟲夏草聯合治療組31例（常規治療基礎上，口服用冬蟲夏草0.5克，每日三次）。動態觀察血尿素氮（BUN）、血肌酐（Cr），尿滲透壓，尿NGA酶，尿量，連續5週。</p>
              <p>結果顯示：冬蟲夏草聯合治療組與常規治療組比較，少尿期和多尿期時間明顯縮短，尿滲透壓第三週後明顯上升（P
                &lt;0.05），尿NAG酶第二週後明顯下降（P &lt;0.05）。</p>
                  <p>研究證實，冬蟲夏草在應用於急性腎功能衰竭患者中，能明顯加快升高尿滲透壓，改善腎小管濃縮、稀釋功能；促進尿NAG酶下降，修復腎小管上皮細胞，故認為冬蟲夏草對急性腎功能衰竭確有良好的防治作用。 </p>
                  <p>冬蟲夏草應用於急性腎功能衰竭31例的臨床對照研究. 雲南中醫中藥雜誌，1996,17（3）</p>
                  <p>隱匿性腎小球腎炎，臨床上多表現為單純性血尿，又稱無症狀血尿。單純性血尿，少數患者有自愈傾向，有部分轉為慢性腎小球腎炎，部分血尿持續存在。目前常用的一般治療用藥，如潘生丁、維生素等效果不滿意，需要尋找有效非激素類藥物治療。</p>
                  <p>本研究選擇了69例，分為常規治療組（32例，潘生丁、維生素E治療），冬蟲夏草聯合治療組37例（常規治療基礎上，口服用冬蟲夏草5克/次，隔日1次）、療程為3個月。</p>
                  <p>療效判斷：（1）血尿轉陰：尿常規檢查正常，尿沉渣中紅細胞
                    &lt;3個/高倍視野，每週二次，連續檢查四周。 （2）無效：尿常規鏡下紅細胞&gt;3個/高倍視野，紅細胞畸形率&gt;75％。</p>
                  <p>觀察治療3個月後的血尿轉陰率，並對患者進行為期兩年的隨診。</p>
                  <p>結果顯示：冬蟲夏草聯合治療組陰轉率為54.05%，常規治療組28.12%（P
                    &lt;0.05）；兩年隨診血尿總轉陰率冬蟲夏草聯合治療組56.76%，常規治療組25%（P&lt;0.05 ），兩組比較均有顯著差異。</p>
                      <p>研究證實，應用冬蟲夏草治療單純性血尿，無論是對症處理或對因治療都是合適的選擇。</p>
                      <p>冬蟲夏草治療單純性血尿的療效觀察. 中國中西醫結合腎病雜誌，2001，2（5）</p>
            </div>
          </div>
          <hr>
          <ul class="ul_li">
            <li>冬蟲夏草治療糖尿病腎病90 例臨床分析</li>
            <li>冬蟲夏草與西藥聯用治療蛋白尿38 例</li>
            <li>冬蟲夏草對慢性腎衰的治療及護理</li>
            <li>冬蟲夏草為主治療慢性腎功能衰竭28 例初步觀察</li>
            <li>冬蟲夏草對慢性腎功能衰竭T 細胞亞群的影響</li>
            <li>黃芪注射液與冬蟲夏草治療慢性腎功能不全24 例臨床觀察</li>
            <li>川芎嗪與冬蟲夏草治療慢性腎功能不全臨床觀察</li>
            <li>中西醫結合治療慢性腎功能衰竭40 例</li>
            <li>冬蟲夏草對老年人氨基糖甙腎毒性損傷的保護作用</li>
            <li>冬蟲夏草治療單純性血尿的療效觀察</li>
            <li>冬蟲夏草治療腎小管功能損害48 例</li>
            <li>冬蟲夏草治療IgA 腎病30 例</li>
            <li>冬蟲夏草和青蒿素抑制狼瘡性腎炎復發的研究</li>
            <li>冬蟲夏草應用於急性腎功能衰竭31 例的臨床對照研究</li>
            <li>冬蟲夏草治療流行性出血熱急性腎損害的研究</li>
            <li>綜合療法加冬蟲夏草防治腎綜合徵出血熱急性腎功能衰竭臨床觀察</li>
            <li>冬蟲夏草治療腎性貧血的臨床研究</li>
            <li>冬蟲夏草對糖尿病腎病大鼠腎損傷的保護作用研究</li>
            <li>冬蟲夏草對2 型糖尿病腎病大鼠細胞凋亡的影響</li>
            <li>冬蟲夏草對糖尿病大鼠腎小管上皮細胞ILK 表達的影響</li>
            <li>冬蟲夏草對糖尿病模型大鼠腎臟的保護作用</li>
            <li>冬蟲夏草在腎間質纖維化大鼠模型中的作用及其對TGF-β1、α-SMA 的影響</li>
          </ul>
        </div>
        <div v-if="part[9].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">10、調節造血機能</h4>
          <div class="red-h4">
            <h4>改善血液病，促進骨髓粒- 單系、紅系造血幹細胞的增殖</h4>
            <h4>改善藥物所致的骨髓造血機能的抑制</h4>
            <h4>促進血小板的生成，抑制異常的血小板聚集</h4>
          </div>
          <div class="flex">
            <div>
              <div class="title-tip">
                <p>《冬蟲夏草對小鼠骨髓粒一單系祖細胞增殖的影響》結果顯示 ：</p>
                <h4>冬蟲夏草能明顯增強及保護造血功能，減輕骨髓抑制</h4>
                <p>1、冬蟲夏草對骨髓粒-單系祖細胞增殖作用的劑量-效應關係</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro10_tab1.jpg" alt="">
              </div>
              <div class="title-tip">
                <p>2、冬蟲夏草對骨髓粒-單系祖細胞增殖作用的時間-效應關係</p>
                <p>（單位：5×104個骨髓有核細胞）</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro10_tab2.jpg" alt="">
              </div>
              <div class="title-tip">
                <p>3、冬蟲夏草對三尖杉酯鹼（Ha）所造成骨髓抑制的拮抗作用</p>
                <p>（單位：5×104個骨髓有核細胞）</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro10_tab3.jpg" alt="">
              </div>
            </div>
            <div>
              <p>骨髓粒-單系祖細胞由造血幹細胞增殖而成，它們進而再增殖分化為各類血細胞，如紅細胞、白細胞、血小板。</p>
              <p>本實驗觀察了冬蟲夏草對小鼠骨髓粒-單系祖細胞增殖的影響，探討其可能對造血細胞的保護作用。</p>
              <p>本實驗將小鼠分為冬蟲夏草組（單次給予不同劑量的冬蟲夏草）和對照組（給予等量生理鹽水），給藥後，取股骨測定骨髓粒-單系祖細胞（CFUGM）,觀察給予冬蟲夏草後劑量-效應關係，和時間-效應關係。同時觀察了冬蟲夏草對具有骨髓抑製作用的三尖杉酯鹼（Ha）所造成的骨髓抑制的拮抗作用。</p>
              <p>結果顯示：</p>
              <p>當冬蟲夏草劑量為4g/kg時，骨髓粒-單系祖細胞產率明顯增高，6g/kg時產率達到高峰。</p>
              <p>給冬蟲夏草後第3天，骨髓粒-單系祖細胞產率達到高峰，第5天產率略降低，但仍然顯著高於對照組，第7天與對照組水平相近。</p>
              <p>事先給予冬蟲夏草6g/kg，可以對抗三尖杉酯鹼對骨髓的抑製作用，使骨髓粒-單系祖細胞產率保持在對照組水平。</p>
              <p>研究證實冬蟲夏草能夠明顯促進骨髓粒-單系祖細胞的增殖，對抗骨髓抑製劑造成的骨髓抑制，增強及保護造血機能。</p>
              <p>冬蟲夏草對小鼠骨髓粒一單系祖細胞增殖的影響 . 湖南醫科大學學報，1989，14（2）</p>
            </div>
          </div>
          <div class="title-tip">
            <p>《中藥冬蟲夏草對白細胞減少症的療效分析》結果顯示：</p>
            <h4>冬蟲夏草可以減輕放、化療的反應，有效治療白細胞減少症</h4>
            <p>服藥後白細胞數比服藥前增加數量（細胞數/mm<sup style="font-size:8px;"> 3</sup>）</p>
          </div>
          <div class="flex">
            <div>
              <img src="../../assets/advertisement/introduceFour/pro10_tab4.jpg" alt="">
            </div>
            <div>
              <p>白細胞減少症是一種頗為常見的慢性疾病。其臨床表現為頭暈、乏力、食慾不振、心悸、失眠並易患感冒。特別是癌症患者在放、化療過程中出現的白細胞減少，是最常見的不良反應。根據本病的表現，中醫歸屬於“虛勞”“血症”的範疇，臨床較為難治。西醫用維生素B4、利血生及激素藥物等治療，有一定療效，但停藥後，白細胞往往重新跌落。近年來，中醫臨床以補脾益腎、益氣補腎、活血等方法治療白細胞減少症效果很好。</p>
              <p>本研究將病人分為對照組（採用常規治療：口服利血生20mg，維生素B410mg，3次/天）和冬蟲夏草組（常規治療+冬蟲夏草6克/天)，連續服用8週。觀察治療前後白細胞計數的變化和不良反應。</p>
              <p>結果顯示：冬蟲夏草組白細胞的增長與對照組比較有顯著性差異，且冬蟲夏草組患者的不適症狀（乏力、食慾不振、反复感冒等），明顯得到改善，無不良反應。</p>
              <p>臨床實踐證明，冬蟲夏草對於治療血液病之白細胞減少症，腫瘤放、化療所致的白細胞減少及各種原因引起的白細胞減少，均有明顯的提升作用。一般1-2週即可見效，而且藥效持久，無不良反應。</p>
              <p>中藥冬蟲夏草對白細胞減少症的療效分析. 中國實用醫藥，2009，4（9）.</p>
            </div>
          </div>
          <hr>

          <ul class="ul_li">
            <li>中藥冬蟲夏草對白細胞減少症的療效分析</li>
            <li>冬蟲夏草對免疫及造血功能影響的實驗研究</li>
            <li>冬蟲夏草對小鼠骨髓粒- 單系祖細胞增殖的影響</li>
            <li>冬蟲夏草對小鼠紅系造血機能的影響</li>
            <li>冬蟲夏草對小鼠造血幹細胞的影響</li>
          </ul>
        </div>
        <div v-if="part[10].part">
          <p style="text-indent:0;">現代藥學與臨床研究發現冬蟲夏草具有多領域、多靶點的藥理作用</p>
          <h4 class="black">11、調節心血管系統功能，改善血液流變學，調節血脂</h4>
          <div class="red-h4">
            <h4>降低心、腦血管疾病發生率</h4>
            <h4>降血脂，預防動脈粥樣硬化</h4>
            <h4>調節血壓，舒張血管，改善血液流變學</h4>
          </div>
          <div class="flex">
            <div>
              <div class="title-tip">
                <p>《冬虫夏草提取物调血脂与抗氧化活性》结果显示：</p>
                <h4>冬虫夏草可以有效调节高脂血症的血脂水平</h4>
                <p>1、與高脂血症組相比，冬蟲夏草組與辛伐他汀組均可有效降低血脂水平</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro11_tab1.jpg" alt="">
              </div>
              <div class="title-tip">
                <p>2、冬蟲夏草能有效升高HDL-C／LDL-C比值，與高脂血症組比較，冬蟲夏草組提高1.52倍，辛伐他汀組提高1.39倍</p>
              </div>
              <div>
                <img src="../../assets/advertisement/introduceFour/pro11_tab2.jpg" alt="">
              </div>
            </div>
            <div>
              <p>本實驗通過建立高脂飲食誘導的高脂血症金黃地鼠模型，研究冬蟲夏草在調血脂與抗氧化方面的活性。</p>
              <p>研究將動物隨機分為正常對照組、高脂血症組、降血脂藥辛伐他汀組（高脂血症動物給予辛伐他汀治療），冬蟲夏草組（冬蟲夏草200mg/kg），各組每天給藥一次，正常對照與模型對照組均給予等容生理鹽水。除正常組給予基礎飼料外，其餘各組均給予高脂飼料。連續給予4週。測定血清總膽固醇（TC），甘油三酯（TG），低密度脂蛋白（LDL-C），高密度脂蛋白（HDL-C）含量。</p>
              <p>研究結果表明：給藥4週後，​​與高脂血症組比較，冬蟲夏草組與辛伐他汀組均有效降低血脂水平（P
                &lt;0.05)。其中，血清總膽固醇（TC），甘油三酯（TG），低密度脂蛋白（LDL-C），高密度脂蛋白（HDL-C），冬蟲夏草組分別降低了58.4%、72.2%、65.4%、 52.1%，辛伐他汀組分別降低了36.8%、89.6%、54.6%、40.8%，並且在升高HDL-C／LDL-C比值方面，與高脂血症組比較，冬蟲夏草組提升了1.52倍，辛伐他汀組提高了1.39倍。</p>
                  <p>研究表明，冬蟲夏草對高脂飲食誘導的高脂血症具有良好的調血脂活性。</p>
                  <p>冬蟲夏草提取物調血脂與抗氧化活性 . 中國實驗方劑學雜誌，2011，17（12）.</p>
            </div>
          </div>
          <hr>
          <ul class="ul_li">
            <li>冬蟲夏草治療心血管疾病的研究進展</li>
            <li>冬蟲夏草在老年醫學上的應用</li>
            <li>老年中風病人血液 RRSF 、RRCF 的變化及冬蟲夏草治療前後的觀察</li>
            <li>黃芪和冬蟲夏草對心髒病左心室舒張功能及血脂的影響</li>
            <li>冬蟲夏草心血管藥理作用研究概況</li>
            <li>冬蟲夏草對腎性高血壓大鼠心血管功能的影響</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script scoped>
export default {
  components: {},
  props: {},
  data() {
    return {
      Fixed: false,

      b1_a: true,
      b2_a: false,
      b3_a: false,
      b4_a: false,

      part : [
        {part: true},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
        {part: false},
      ],

      On: [
        {isOn: true},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false},
        {isOn: false}
      ]
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleScroll () {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			var offsetTop = document.querySelector('.z_nav').offsetTop
			if (Number(scrollTop) + 130 > offsetTop) {
				this.Fixed = true
			} else {
				this.Fixed = false
			}

      var nowTop = Number(scrollTop) + 232;
      var bankuai_one_top = document.querySelector('.one').offsetTop;
			var bankuai_two_top = document.querySelector('.two').offsetTop;
			var bankuai_three_top = document.querySelector('.three').offsetTop;
      var bankuai_four_top = document.querySelector('.effect').offsetTop;

      if (nowTop > bankuai_one_top && nowTop < bankuai_two_top) {
				this.b2_a = false;
				this.b1_a = true;
				this.b3_a = false;
				this.b4_a = false;
			} else if (nowTop > bankuai_two_top && nowTop < bankuai_three_top) {
				this.b2_a = true;
				this.b1_a = false;
				this.b3_a = false;
				this.b4_a = false;
			} else if (nowTop > bankuai_three_top && nowTop < bankuai_four_top) {
				this.b2_a = false;
				this.b1_a = false;
				this.b3_a = true;
				this.b4_a = false;
			} else if (nowTop > bankuai_four_top) {
				this.b2_a = false;
				this.b1_a = false;
				this.b3_a = false;
				this.b4_a = true;
			}
    },
    btn1 () {
			var b_1_Top = document.querySelector('.one').offsetTop;
      window.scrollTo(0,Number(b_1_Top) - 232);
      this.b2_a = false;
			this.b1_a = true;
			this.b3_a = false;
			this.b4_a = false;

		},
		btn2 () {
			var b_2_Top = document.querySelector('.two').offsetTop;
			window.scrollTo(0,Number(b_2_Top) - 232);
			this.b2_a = true;
			this.b1_a = false;
			this.b3_a = false;
			this.b4_a = false;
		},
		btn3 () {
			var b_3_Top = document.querySelector('.three').offsetTop;
			window.scrollTo(0,Number(b_3_Top) - 232);
			this.b2_a = false;
			this.b1_a = false;
			this.b3_a = true;
			this.b4_a = false;
		},
		btn4 () {
			var b_4_Top = document.querySelector('.effect').offsetTop;
			window.scrollTo(0,Number(b_4_Top) - 232);
			this.b2_a = false;
			this.b1_a = false;
			this.b3_a = false;
			this.b4_a = true;
    },

    choose_1 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[0].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[0].isOn = true;
    },
    choose_2 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[1].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[1].isOn = true;
    },
    choose_3 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[2].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[2].isOn = true;
    },
    choose_4 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[3].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[3].isOn = true;
    },
    choose_5 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[4].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[4].isOn = true;
    },
    choose_6 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[5].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[5].isOn = true;
    },
    choose_7 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[6].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[6].isOn = true;
    },
    choose_8 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[7].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[7].isOn = true;
    },
    choose_9 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[8].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[8].isOn = true;
    },
    choose_10 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[9].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[9].isOn = true;
    },
    choose_11 () {
      for (var i = 0; i < this.part.length; i++) {
        this.part[i].part = false;
      }
      this.part[10].part = true;
      for (var j = 0; j < this.On.length; j++) {
        this.On[j].isOn = false;
      }
      this.On[10].isOn = true;
    }
  },
  created() {
    window.scrollTo(0,0)
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style scoped>
@import "../../css/introduceFour.css";

.fix {
  position: fixed;
  top: 130px;
}

.active {
	color: #9c0001;
}
</style>



// WEBPACK FOOTER //
// src/pages/advertisement/IntroduceFour.vue